<template>
  <Modal
    width="496"
    v-model.trim="cForm.modal"
    :title="cForm.id ? '编辑' : '新增'"
    :loading="cForm.loading"
    @on-ok="submit"
  >
    <Form
      class="c-form c-form--modal"
      ref="form"
      :model="cForm.model"
      :rules="cForm.rules"
      :label-width="80"
    >
      <Form-item label="认养单位" prop="unit">
        <Input
          class="c-form__input"
          v-model.trim="cForm.model.unit"
          placeholder="请输入认养单位"
        />
      </Form-item>
      <Form-item label="认养人" prop="name">
        <Input
          class="c-form__input"
          v-model.trim="cForm.model.name"
          placeholder="请输入认养人"
        />
      </Form-item>
      <Form-item label="联系人" prop="contactName">
        <Input
          class="c-form__input"
          v-model.trim="cForm.model.contactName"
          placeholder="请输入联系人"
        />
      </Form-item>
      <Form-item label="联系人手机号" prop="contact">
        <Input
          class="c-form__input"
          v-model.trim="cForm.model.contact"
          placeholder="请输入联系人手机号"
        />
      </Form-item>
    </Form>
  </Modal>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import FormMixin from "@/mixins/form";

const module = "treeAdoptions";

@Component({
  mixins: [FormMixin]
})
export default class extends Vue {
  data() {
    return {
      cForm: {
        id: 0,
        modal: false,
        loading: true,
        model: this.getFormInitModel(),
        rules: {
          contactName: [
            {
              required: true,
              message: "联系人不能为空"
            }
          ],
          contact: [
            {
              required: true,
              message: "联系人手机号不能为空"
            },
            {
              pattern: /^1\d{2}\s?\d{4}\s?\d{4}$/,
              message: "联系人手机号格式错误"
            }
          ]
        }
      }
    };
  }

  getFormInitModel() {
    return {
      status: 1
    };
  }

  show(detail) {
    this.cForm.modal = true;

    if (detail && detail.id) {
      this.cForm.id = detail.id;
      this.initFormFields(detail);
    } else {
      this.cForm.id = 0;
    }
  }

  submit() {
    this.$refs.form.validate(async valid => {
      if (valid) {
        const { id, model } = this.cForm;

        if (!model.unit && !model.name) {
          this.$Message.error("认养单位和认养人至少填一个");
          return;
        }

        await this.$store.dispatch(`${module}/${id ? "put" : "post"}`, {
          id,
          body: model
        });

        this.cForm.modal = false;
        this.$Message.success(`${id ? "编辑" : "新增"}成功`);
        this.$emit("get-list");
      }

      this.fixFormButtonLoading();
    });
  }
}
</script>
